var map = {
	"./about-ch2-urbanproblems-climatechange.svg": "3ca5",
	"./about-ch2-urbanproblems-globe.svg": "9b47",
	"./about-ch2-urbanproblems-greenhousegas.svg": "c597",
	"./about-ch2-urbanproblems-inclusivity.svg": "b678",
	"./about-ch2-urbanproblems-inequality.svg": "9e85",
	"./about-ch2-urbanproblems-megacities.svg": "5527",
	"./about-ch2-urbanproblems-naturaldisasters.svg": "cd37"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "36ed";